<!-- ===================================== -->
<!-- Floating Toggle Button -->
<!-- ===================================== -->
<button class="chat-toggle-btn" (click)="toggleChat()">
  <span *ngIf="!isOpen">💬</span>
  <span *ngIf="isOpen">✕</span>
</button>

<!-- ===================================== -->
<!-- Floating Chat Widget -->
<!-- ===================================== -->
<div class="chat-widget" [class.open]="isOpen">

  <div class="chat-container">

    <!-- ===================================== -->
    <!-- Header -->
    <!-- ===================================== -->
    <div class="chat-header">
      <div style="font-size: 1.2em">Google Assistant Privacy Administrator<br />
      <span style="font-size: .9em">(AI Chat Bot)</span></div>
    </div>

    <!-- ===================================== -->
    <!-- Messages -->
    <!-- ===================================== -->
    <div class="chat-messages" #chatContainer>
      <div *ngFor="let message of messages"
           class="message"
           [ngClass]="message.role">

        <div class="message-content">
         
          <div [innerHTML]="formatMessage(message.content)"></div>

          <div class="message-timestamp">
            {{ message.timestamp | date:'shortTime' }}
          </div>
        </div>
      </div>
    </div>

    <!-- ===================================== -->
    <!-- Input -->
    <!-- ===================================== -->
    <div class="chat-input-container">
      <input class="chat-input"
             type="text"
             placeholder="Type your message..."
             [(ngModel)]="userInput"
             (keydown)="onKeyPress($event)"
             [disabled]="isLoading" />

      <button type="button" class="send-btn"
              (click)="sendMessage()"
              [disabled]="isLoading || !userInput.trim()">
        Send
      </button>
    </div>
  </div>
</div>

